import Cookies from 'js-cookie'
import { baseUrl } from '@/utils/constant';

const TokenKey = '_SKILLBOX_SID'

export function getToken() {
  return Cookies.get(baseUrl.UC_SID_KEY)
}

export function setToken(token) {
  return Cookies.set(baseUrl.UC_SID_KEY, token)
}

export function getRcToken(){
  return Cookies.get('RCTOKEN')
}

export function getRcUid(){
  return Cookies.get('RCUID')
}

export function removeToken() {
  Cookies.remove('PHPSESSID')
  Cookies.remove('SESSION')
  localStorage.removeItem('permissions')
  localStorage.removeItem('user')
  return Cookies.remove(baseUrl.UC_SID_KEY)
}
